import { SignInResponseSchema } from '../auth-sso/signed-in-session.schema';
import { SwitchTenantRequestSchema } from './switch-tenant.schema';
/**
 * Switch Tenant Endpoint Contract
 * Mints a fresh session for another tenant the caller's identity holds an
 * active membership in — no IdP round-trip.
 */ export const switchTenantContract = {
    method: 'POST',
    path: '/api/v2/auth/switch-tenant',
    description: 'Switches the session to another tenant of the same identity, returns a fresh JWT token and tenant',
    requestSchema: SwitchTenantRequestSchema,
    responseSchema: SignInResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body',
            401: 'Missing or invalid access token, or target tenant expired',
            403: 'No active membership for the target tenant (or legacy session without identity)'
        }
    }
};

//# sourceMappingURL=switch-tenant.contract.js.map